<mat-card class="no-padding margin-bottom-10">
    <mat-card-title>
        <img src="/images/wrench_ym_logo.svg" alt="Wrench">
    </mat-card-title>
    <mat-card-content>
        <h1 class="margin-bottom-small text-bold">A new Wrench experience is on the way!</h1>
        <p class="main-message color-light-grey">While we make a few system upgrades Wrench customers will be supported by
            YourMechanic, a subsidiary of Wrench, to submit bookable quotes, book services and manage appointments.</p>
        <a class="text-bold margin-bottom-small" href="/faq">
            Learn More
            <fa-icon icon="arrow-right" class="color-light-blue"></fa-icon>
        </a>
        <button mat-flat-button (click)="navigate()" color="accent">
            Continue
        </button>
        <p class="color-darkgrey">We will redirect you automatically in {{counter}} seconds.</p>
        <p class="color-darkgrey">YourMechanic is a subsidiary of Wrench Inc. Existing Wrench Users will need to create
            a new account when creating new bookable quotes. For more information, follow the Learn More link above.</p>
    </mat-card-content>
</mat-card>
